/*
 *   File : declaration-upload.js
 *   Author URI : https://evoqins.com
 *   Description : Upload declaration documents.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "bootstrap";

import { CustomFilePicker, FilePreview } from "../../../Component/Form-elements";
import { GradientButton } from "../../../Component/CTA";
import { FatcaOTPVerification } from "../../../Component/Modal";

import APIService from "../../../Service/api-service";
import { _isFileTypeAllowed } from "../../../Helper";
import { _uploadDocumentToS3 } from "../../../Service/aws-service";
import Store from "../../../Store";

export default function UploadDeclaration(props) {
    const formRef = useRef(null);
    const PROGRESS_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA);

    const [kycFormKarta, setKycFormKarta] = useState(null);
    const [kycFormKartaError, setKycFormKartaError] = useState("");

    const [kycFormCoparcener, setKycFormCoparcener] = useState(null);
    const [kycFormCoparcenerError, setKycFormCoparcenerError] = useState("");

    const [accountOpeningForm, setAccountOpeningForm] = useState(null);
    const [accountOpeningFormError, setAccountOpeningFormError] = useState("");

    const [nonIndividualKyc, setNonIndividualKyc] = useState(null);
    const [nonIndividualKycError, setNonIndividualKycError] = useState("");

    const [foreignTax, setForeignTax] = useState(null);
    const [foreignTaxError, setForeignTaxError] = useState("");

    const [nonIndividualCoparcener, setNonIndividualCoparcener] = useState(null);
    const [nonIndividualCoparcenerError, setNonIndividualCoparcenerError] = useState("");

    const [showPinModal, setShowPinModal] = useState(false);
    const [formData, setFormData] = useState(null);
    const [fileLoader, setFileLoader] = useState(false);
    const [apiLoader, setApiLoader] = useState(false);
    const [btnLoader, setBtnLoader] = useState(false);

    useEffect(() => {
        if (showPinModal === true) {
            const modal = new Modal(document.getElementById("form-otp"));
            modal.show()
        }
    }, [showPinModal]);

    useEffect(() => {
        if (PROGRESS_DATA.karta_kyc_form_signed_url !== null) {
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.karta_kyc_form_signed_url));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setKycFormKarta(fileName)
        }
        // if (PROGRESS_DATA.coparcener_kyc_form_signed_url !== null) {
        //     const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.coparcener_kyc_form_signed_url));
        //     // Extract file name from URL
        //     const fileName = decodedURL.split('?')[0].split("/").pop();
        //     setKycFormCoparcener(fileName)
        // }
        if (PROGRESS_DATA.bse_form_signed_url !== null) {
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.bse_form_signed_url));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setAccountOpeningForm(fileName)
        }
        // if (PROGRESS_DATA.ubo_form_signed_url !== null) {
        //     const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.ubo_form_signed_url));
        //     // Extract file name from URL
        //     const fileName = decodedURL.split('?')[0].split("/").pop();
        //     setNonIndividualKyc(fileName)
        // }
        if (PROGRESS_DATA.ubo_form_signed_url !== null) {
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.ubo_form_signed_url));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setForeignTax(fileName)
        }
        if (PROGRESS_DATA.non_ind_coparcener_form_signed_url !== null) {
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.non_ind_coparcener_form_signed_url));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setNonIndividualCoparcener(fileName)
        }

    }, [PROGRESS_DATA])

    function _handleInputFields(type, value, file) {
        // eslint-disable-next-line
        var file_formatted = value.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');

        switch (type) {
            case 1:
                if (parts.length > 1) {
                    const extension = '.' + parts.pop();
                    if (_isFileTypeAllowed(extension)) {
                        // checking if file size is greater than 5mb
                        const file_size = 5 * 1024 * 1024
                        if (file.size < file_size) {
                            _fileUpload(file_formatted, file, 1);
                        } else {
                            setKycFormKartaError("File size should be less than 5mb");
                        }
                    }
                    else {
                        setKycFormKartaError("File type should be .pdf, .jpeg, .jpg, .png");
                    }
                }
                break;

            case 3:
                if (parts.length > 1) {
                    const extension = '.' + parts.pop();
                    if (_isFileTypeAllowed(extension)) {
                        // checking if file size is greater than 5mb
                        const file_size = 5 * 1024 * 1024
                        if (file.size < file_size) {
                            _fileUpload(file_formatted, file, 3);
                        } else {
                            setAccountOpeningFormError("File size should be less than 5mb");
                        }
                    }
                    else {
                        setAccountOpeningFormError("File type should be .pdf, .jpeg, .jpg, .png");
                    }
                }
                break;

            case 4:
                if (parts.length > 1) {
                    const extension = '.' + parts.pop();
                    if (_isFileTypeAllowed(extension)) {
                        // checking if file size is greater than 5mb
                        const file_size = 5 * 1024 * 1024
                        if (file.size < file_size) {
                            _fileUpload(file_formatted, file, 4);
                        } else {
                            setForeignTaxError("File size should be less than 5mb");
                        }
                    }
                    else {
                        setForeignTaxError("File type should be .pdf, .jpeg, .jpg, .png");
                    }
                }
                break;
            case 5:
                if (parts.length > 1) {
                    const extension = '.' + parts.pop();
                    if (_isFileTypeAllowed(extension)) {
                        // checking if file size is greater than 5mb
                        const file_size = 5 * 1024 * 1024
                        if (file.size < file_size) {
                            _fileUpload(file_formatted, file, 5);
                        } else {
                            setNonIndividualCoparcenerError("File size should be less than 5mb");
                        }
                    }
                    else {
                        setNonIndividualCoparcenerError("File type should be .pdf, .jpeg, .jpg, .png");
                    }
                }
                break;
            default: break;
        }
    }


    function _resetErrors(type) {
        switch (type) {
            case 1:
                setKycFormKartaError("");
                break;

            case 3:
                setAccountOpeningFormError("");
                break;

            case 4:
                setForeignTaxError("");
                break;
            case 5:
                setNonIndividualCoparcenerError("");
                break;

            default:
                break;
        }
    }

    function _setFileUrls(type, url, key) {
        switch (type) {
            case 1:
                setKycFormKarta(key);
                break;
            // case 2:
            //     setKycFormCoparcener(key);
            //     break;
            case 3:
                setAccountOpeningForm(key);
                break;
            // case 4:
            //     setNonIndividualKyc(key);
            //     break;
            case 4:
                setForeignTax(key);
                break;
            case 5:
                setNonIndividualCoparcener(key);
                break;

            default:
                break;
        }
    }

    //API :: file upload api
    const _fileUpload = (key, file, type) => {
        setFileLoader(type);
        _resetErrors(type)

        let url = "general/file-upload";
        let body = {
            "key": `support/${key}`
        }

        APIService(true, url, body).then((response) => {
            if (response.status_code === 200) {
                setFileLoader(type);

                // s3 helper
                _uploadDocumentToS3(response.data, key, file).then((result) => {
                    _uploadForm(type, response.data.view_info, key)
                }).catch(error => {
                    toast.dismiss();
                    toast.error(error, {
                        type: "error",
                    });
                    setFileLoader(false);
                });

            } else {
                setFileLoader(false);
                toast.dismiss();
                toast.error(response, {
                    type: "error",
                });
            }
        })
    }

    function _validateForm() {
        let valid = true;
        if (kycFormKarta === null) {
            setKycFormKartaError("Please upload file");
            formRef.current.scrollIntoView()
            valid = false
        }
        // if (kycFormCoparcener === null) {
        //     setKycFormCoparcenerError("Please upload file");
        //     formRef.current.scrollIntoView()
        //     valid = false
        // }
        if (accountOpeningForm === null) {
            setAccountOpeningFormError("Please upload file");
            formRef.current.scrollIntoView()
            valid = false
        }
        // if (nonIndividualKyc === null) {
        //     setNonIndividualKycError("Please upload file");
        //     formRef.current.scrollIntoView()
        //     valid = false
        // }
        if (foreignTax === null) {
            setForeignTaxError("Please upload file");
            valid = false
        }
        if (nonIndividualCoparcener === null) {
            setNonIndividualCoparcenerError("Please upload file");
            valid = false
        }
        if (valid === true) {
            _requestOtp()
        }
    }

    async function _submitOtp(otp) {
        setBtnLoader(true);
        let valid = false;
        let url = 'kyc/verify-2fa-form';
        let payload = {
            otp: otp,
            is_review:props.edit
        }
        await APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                setBtnLoader(false);
                  Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: response.kyc_data
                });
                valid = true
            } else {
                toast.dismiss();
                toast.error(response.message);
                setBtnLoader(false);
                valid = false
            }
        })
        return valid
    }

    const _requestOtp = (is_resend = false) => {
        if (is_resend === false) {
            setApiLoader(true);
        }
        let url = 'kyc/request-2fa-form';

        APIService(false, url).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                setShowPinModal(true);
                if (is_resend) {
                    toast.success('OTP has been re-sent to your registered email and phone number', {
                        type: "success"
                    });
                } else {
                    toast.success('OTP has been sent to your registered email and phone number', {
                        type: "success"
                    });
                }
            } else {

                toast.error(response.message)
            }
            setApiLoader(false);
        })
    }

    const _getForms = (type) => {
        setFormData(type);
        let url = 'kyc/digilocker/create-form';
        let payload = {
            file_type: type
        }
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                window.open(response.data, "_blank");
            } else {
                toast.dismiss();
                toast.error(response.message)
            }
            setFormData(null);
        })
    }

    const _uploadForm = (type, url, key) => {
        let api_url = 'kyc/digilocker/upload-form';
        let payload = {
            file_type: type,
            url: url
        }
        APIService(true, api_url, payload).then((response) => {
            if (response.status_code === 200) {
                _setFileUrls(type, url, key);
                setFileLoader(false);
            } else {
                toast.dismiss();
                toast.error(response.message)
            }
        })
    }

    return (
        <div className="row" ref={formRef}>
            <div className="col-12" >
                <h2 className="color-black e-inter-bold e-font-24 mb-2">
                    AOF, FATCA, & UBO declaration
                </h2>
                <p className="color-outer-space e-poppins-regular e-font-16 mb-4">
                    To complete the investment process, submission of the Account Opening Form (AOF), Foreign Account Tax Compliance Act (FATCA) declaration, and Ultimate Beneficial Ownership (UBO) details is required.
                </p>
                <p className="color-black e-poppins-medium e-font-14 line-height-24px mb-4">Karta Needs to Complete & Upload the Forms step by step</p>

                {/* Karta */}
                <div className="row pt-3" >
                    <span className="color-jett-black e-poppins-semi-bold e-font-16 line-height-24px mb-3">1. Upload karta’s KYC form</span>
                    <div className="col-lg-5 col-sm-6">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">1. Download the form</p>
                        <div className="border-columbia-blue border-all border-radius-16px padding-12px-tb px-3 d-flex align-items-center justify-content-between mt-3 cursor-pointer"
                            onClick={() => _getForms(1)}>
                            <div className="d-flex color-dim-gray gap-2 align-items-center e-inter-regular e-font-14">
                                <img src={require("../../../Assets/Images/kyc/pdf.png")}
                                    alt="pdf"
                                    width={40}
                                    height={40} />
                                karta’s KYC form
                            </div>
                            {formData === 1 ?
                                <img src={require('../../../Assets/Images/loader.gif')}
                                    width={40}
                                    height={40} />
                                :
                                <img src={require("../../../Assets/Images/kyc/download.png")}
                                    alt="pdf"
                                />}
                        </div>
                        <div className="d-flex gap-2 color-primary-color e-font-12 e-poppins-regular mt-2 align-items-center">

                            <img src={require('../../../Assets/Images/kyc/info-circle.svg').default}
                                alt="Info" />
                            *We required forms with stamp & signature.
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 pt-lg-0 pt-4">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">2. Upload the form</p>
                        <p className="color-black e-font-14 e-poppins-regular mb-1"> Upload KYC form of karta</p>
                        {
                            kycFormKarta === null ?

                                <CustomFilePicker accept=".png, .pdf, .jpeg "
                                    className="e-select-file"
                                    error={kycFormKartaError}
                                    loading={fileLoader === 1}
                                    onSelectFile={(value, file) => _handleInputFields(1, value, file)} />
                                :
                                <FilePreview fileName={kycFormKarta}
                                    removeFile={() => {
                                        setKycFormKarta(null);
                                        setKycFormKartaError("");
                                    }} />
                        }

                    </div>
                    <div className="col-lg-3 pt-lg-4 mt-lg-4">
                        {kycFormKarta !== null && <span className="color-ufo-green e-poppins-regular e-font-14  pt-3">Successfully uploaded the form</span>}
                    </div>
                </div>

                {/* coparcener */}
                {false && <div className="row pt-3">
                    <span className="color-jett-black e-poppins-medium e-font-12 my-3">Upload coparcener’s KYC form</span>
                    <div className="col-lg-5 col-sm-6">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">1. Download the form</p>
                        <div className="border-columbia-blue border-all border-radius-16px padding-12px-tb px-3 d-flex align-items-center justify-content-between mt-3 cursor-pointer"
                            onClick={() => _getForms(2)}>
                            <div className="d-flex color-dim-gray gap-2 align-items-center e-inter-regular e-font-14">
                                <img src={require("../../../Assets/Images/kyc/pdf.png")}
                                    alt="pdf"
                                    width={40}
                                    height={40} />
                                Account opening form
                            </div>
                            {formData === 2 ?
                                <img src={require('../../../Assets/Images/loader.gif')}
                                    width={40}
                                    height={40} />
                                :
                                <img src={require("../../../Assets/Images/kyc/download.png")}
                                    alt="pdf"
                                />}
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 pt-lg-0 pt-4">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">2. Upload the form</p>
                        <p className="color-black e-font-14 e-poppins-regular mb-1">Upload KYC form of coparcener</p>
                        {
                            kycFormCoparcener === null ?

                                <CustomFilePicker accept=".png, .pdf, .jpeg "
                                    className="e-select-file"
                                    error={kycFormCoparcenerError}
                                    loading={fileLoader === 2}
                                    onSelectFile={(value, file) => _handleInputFields(2, value, file)} />
                                :
                                <FilePreview fileName={kycFormCoparcener}
                                    removeFile={() => {
                                        setKycFormCoparcener(null);
                                        setKycFormCoparcenerError("");
                                    }} />
                        }

                    </div>
                    <div className="col-lg-3 pt-lg-4 mt-lg-4">
                        {
                            kycFormCoparcener !== null && <span className="color-ufo-green e-poppins-regular e-font-14  pt-3">Successfully uploaded the form</span>
                        }
                    </div>
                </div>}

                {/* account opening */}
                <div className="row pt-3">
                    <span className="color-jett-black e-poppins-semi-bold e-font-16 line-height-24px mt-4 mb-3">2. Account opening form (BSE /AOF)</span>
                    <div className="col-lg-5 col-sm-6">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">1. Download the form</p>
                        <div className="border-columbia-blue border-all border-radius-16px padding-12px-tb px-3 d-flex align-items-center justify-content-between mt-3 cursor-pointer"
                            onClick={() => _getForms(3)}>
                            <div className="d-flex color-dim-gray gap-2 align-items-center e-inter-regular e-font-14">
                                <img src={require("../../../Assets/Images/kyc/pdf.png")}
                                    alt="pdf"
                                    width={40}
                                    height={40} />
                                Account opening form (BSE /AOF)
                            </div>
                            {formData === 3 ?
                                <img src={require('../../../Assets/Images/loader.gif')}
                                    width={40}
                                    height={40} />
                                :
                                <img src={require("../../../Assets/Images/kyc/download.png")}
                                    alt="pdf"
                                />}
                        </div>
                        <div className="d-flex gap-2 color-primary-color e-font-12 e-poppins-regular mt-2 align-items-center">

                            <img src={require('../../../Assets/Images/kyc/info-circle.svg').default}
                                alt="Info" />
                            *We required forms with stamp & signature.
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 pt-lg-0 pt-4">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">2. Upload the form</p>
                        <p className="color-black e-font-14 e-poppins-regular mb-1">Upload AOF</p>
                        {
                            accountOpeningForm === null ?

                                <CustomFilePicker accept=".png, .pdf, .jpeg "
                                    className="e-select-file"
                                    error={accountOpeningFormError}
                                    loading={fileLoader === 3}
                                    onSelectFile={(value, file) => _handleInputFields(3, value, file)} />
                                :
                                <FilePreview fileName={accountOpeningForm}
                                    removeFile={() => {
                                        setAccountOpeningForm(null);
                                        setAccountOpeningFormError("");
                                    }} />
                        }

                    </div>
                    <div className="col-lg-3 pt-lg-4 mt-lg-4">
                        {
                            accountOpeningForm !== null && <span className="color-ufo-green e-poppins-regular e-font-14  pt-3">Successfully uploaded the form</span>
                        }
                    </div>
                </div>

                {/* non individual kyc karta */}
                {false && <div className="row pt-3">
                    <span className="color-jett-black e-poppins-semi-bold e-font-16 line-height-24px mt-4 mb-3">3. Non Individual -KYC (BSE AOF)</span>
                    <div className="col-lg-5 col-sm-6">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">1. Download the form</p>
                        <div className="border-columbia-blue border-all border-radius-16px padding-12px-tb px-3 d-flex align-items-center justify-content-between mt-3 cursor-pointer"
                            onClick={() => _getForms(4)}>
                            <div className="d-flex color-dim-gray gap-2 align-items-center e-inter-regular e-font-14">
                                <img src={require("../../../Assets/Images/kyc/pdf.png")}
                                    alt="pdf"
                                    width={40}
                                    height={40} />
                                Ultimate Beneficial Ownership
                            </div>
                            {formData === 4 ?
                                <img src={require('../../../Assets/Images/loader.gif')}
                                    width={40}
                                    height={40} />
                                :
                                <img src={require("../../../Assets/Images/kyc/download.png")}
                                    alt="pdf"
                                />}
                        </div>
                        <div className="d-flex gap-2 color-primary-color e-font-12 e-poppins-regular mt-2 align-items-center">

                            <img src={require('../../../Assets/Images/kyc/info-circle.svg').default}
                                alt="Info" />
                            *We required forms with stamp & signature.
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 pt-lg-0 pt-4">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">2. Upload the form</p>
                        <p className="color-black e-font-14 e-poppins-regular mb-1">Upload non individual KYC (BSE AOF)</p>
                        {
                            nonIndividualKyc === null ?

                                <CustomFilePicker accept=".png, .pdf, .jpeg "
                                    className="e-select-file"
                                    error={nonIndividualKycError}
                                    loading={fileLoader === 4}
                                    onSelectFile={(value, file) => _handleInputFields(4, value, file)} />
                                :
                                <FilePreview fileName={nonIndividualKyc}
                                    removeFile={() => {
                                        setNonIndividualKyc(null);
                                        setNonIndividualKycError("");
                                    }} />
                        }

                    </div>
                    <div className="col-lg-3 pt-lg-4 mt-lg-4">
                        {
                            nonIndividualKyc !== null && <span className="color-ufo-green e-poppins-regular e-font-14  pt-3">Successfully uploaded the form</span>
                        }
                    </div>
                </div>}

                {/*foreign tax */}
                <div className="row pt-3">
                    <span className="color-jett-black e-poppins-semi-bold e-font-16 line-height-24px mt-4 mb-3">3. Foreign Account Tax Compliance Act / Ultimate Beneficial Ownership</span>
                    <div className="col-lg-5 col-sm-6">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">1. Download the form</p>
                        <div className="border-columbia-blue border-all border-radius-16px padding-12px-tb px-3 d-flex align-items-center justify-content-between mt-3 cursor-pointer"
                            onClick={() => _getForms(4)}>
                            <div className="d-flex color-dim-gray gap-2 align-items-center e-inter-regular e-font-14">
                                <img src={require("../../../Assets/Images/kyc/pdf.png")}
                                    alt="pdf"
                                    width={40}
                                    height={40} />
                                FATCA /UBO
                            </div>
                            {formData === 4 ?
                                <img src={require('../../../Assets/Images/loader.gif')}
                                    width={40}
                                    height={40} />
                                :
                                <img src={require("../../../Assets/Images/kyc/download.png")}
                                    alt="pdf"
                                />}
                        </div>
                        <div className="d-flex gap-2 color-primary-color e-font-12 e-poppins-regular mt-2 align-items-center">

                            <img src={require('../../../Assets/Images/kyc/info-circle.svg').default}
                                alt="Info" />
                            *We required forms with stamp & signature.
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 pt-lg-0 pt-4">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">2. Upload the form</p>
                        <p className="color-black e-font-14 e-poppins-regular mb-1">Upload FATCA/UBO</p>
                        {
                            foreignTax === null ?

                                <CustomFilePicker accept=".png, .pdf, .jpeg "
                                    className="e-select-file"
                                    error={foreignTaxError}
                                    loading={fileLoader === 4}
                                    onSelectFile={(value, file) => _handleInputFields(4, value, file)} />
                                :
                                <FilePreview fileName={foreignTax}
                                    removeFile={() => {
                                        setForeignTax(null);
                                        setForeignTaxError("");
                                    }} />
                        }

                    </div>
                    <div className="col-lg-3 pt-lg-4 mt-lg-4">
                        {
                            foreignTax !== null && <span className="color-ufo-green e-poppins-regular e-font-14  pt-3">Successfully uploaded the form</span>
                        }
                    </div>
                </div>


                {/*Non individual coparcener list */}
                <div className="row pt-3">
                    <span className="color-jett-black e-poppins-semi-bold e-font-16 line-height-24px mt-4 mb-3">4. Non individual coparcener list</span>
                    <div className="col-lg-5 col-sm-6">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">1. Download the form</p>
                        <div className="border-columbia-blue border-all border-radius-16px padding-12px-tb px-3 d-flex align-items-center justify-content-between mt-3 cursor-pointer"
                            onClick={() => _getForms(5)}>
                            <div className="d-flex color-dim-gray gap-2 align-items-center e-inter-regular e-font-14">
                                <img src={require("../../../Assets/Images/kyc/pdf.png")}
                                    alt="pdf"
                                    width={40}
                                    height={40} />
                                Non individual coparcener list
                            </div>
                            {formData === 5 ?
                                <img src={require('../../../Assets/Images/loader.gif')}
                                    width={40}
                                    height={40} />
                                :
                                <img src={require("../../../Assets/Images/kyc/download.png")}
                                    alt="pdf"
                                />}
                        </div>
                        <div className="d-flex gap-2 color-primary-color e-font-12 e-poppins-regular mt-2 align-items-center">

                            <img src={require('../../../Assets/Images/kyc/info-circle.svg').default}
                                alt="Info" />
                            *We required forms with stamp & signature.
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 pt-lg-0 pt-4">
                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">2. Upload the form</p>
                        <p className="color-black e-font-14 e-poppins-regular mb-1">Upload non individual coparcener</p>
                        {
                            nonIndividualCoparcener === null ?

                                <CustomFilePicker accept=".png, .pdf, .jpeg "
                                    className="e-select-file"
                                    error={nonIndividualCoparcenerError}
                                    loading={fileLoader === 5}
                                    onSelectFile={(value, file) => _handleInputFields(5, value, file)} />
                                :
                                <FilePreview fileName={nonIndividualCoparcener}
                                    removeFile={() => {
                                        setNonIndividualCoparcener(null);
                                        setNonIndividualCoparcenerError("");
                                    }} />
                        }

                    </div>
                    <div className="col-lg-3 pt-lg-4 mt-lg-4">
                        {
                            nonIndividualCoparcener !== null && <span className="color-ufo-green e-poppins-regular e-font-14  pt-3">Successfully uploaded the form</span>
                        }
                    </div>
                </div>
                <GradientButton label="Submit"
                    className="px-3 padding-12px-tb e-font-16 margin-40px-top"
                    loading={apiLoader}
                    handleClick={_validateForm} />
                {/*  */}
            </div>
            {
                showPinModal === true && (
                    <FatcaOTPVerification close={() => setShowPinModal(false)}
                        handleOTPSubmission={_submitOtp}
                        loader={btnLoader}
                        resendOtp={_requestOtp}
                        handleSuccess={() => props.updateProgress(PROGRESS_DATA.is_review ? 8 : 7, props.text, props.is_manual)}
                    />
                )
            }
        </div>
    )
}
